export namespace DriverBankTransactionReasonConstants {
  export const REFERRED_DRIVER_INCENTIVE: string = 'Referred Driver Incentive';
  export const REFERRED_RIDER_INCENTIVE: string = 'Referred Rider Incentive';
  export const DRIVER_CANCELLATION_FEE: string = 'Driver Cancellation Fee';
  export const NOSHOW_FEE: string = 'Noshow Fee';
  export const RIDER_CANCELLATION_CREDIT: string = 'Rider Cancellation Credit';
  export const RIDER_INCENTIVE_CREDIT: string = 'Rider Incentive Credit';
  export const RESERVATION_FEE: string = 'Reservation Fee';
  export const PAYOUT: string = 'Payout';
  export const MISC_CREDIT: string = 'Misc Credit';
  export const MISC_DEBIT: string = 'Misc Debit';
  export const PAYOUT_FEE: string = 'Payout Fee';
  export const DRIVER_COMMISSION_CREDIT: string = 'Driver Commission Credit';

  export const DRIVER_BANK_TRANSACTION_CREDIT_REASONS = [
    REFERRED_DRIVER_INCENTIVE,
    REFERRED_RIDER_INCENTIVE,
    RIDER_CANCELLATION_CREDIT,
    RIDER_INCENTIVE_CREDIT,
    MISC_CREDIT,
    DRIVER_COMMISSION_CREDIT
  ];

  export const DRIVER_BANK_TRANSACTION_DEBIT_REASONS = [
    DRIVER_CANCELLATION_FEE,
    NOSHOW_FEE,
    RESERVATION_FEE,
    PAYOUT,
    MISC_DEBIT,
    PAYOUT_FEE
  ];
}

